import {
  CloseOutlined as CloseIcon,
  KeyboardBackspaceRounded as BackspaceIcon,
  PrintRounded as PrintIcon,
} from '@material-ui/icons';

import { dpReduxAction } from 'shared/infra/redux';
import orderActions from 'redux/actions/orders-actions/orders.actions';

import makeClasses from './SFMainDialogHeader.style';

import type { OrderId } from 'shared/domain';
import type { DrawerProps } from '@material-ui/core/Drawer';

export function SFMainDialogHeader(props: Props) {
  const { orderId, onBack, onClose = () => {} } = props;

  const handleToPrint = () => {
    onBack();
    setTimeout(() => dpReduxAction(orderActions.sendToPrint(orderId)), 200);
  };

  const _classes = makeClasses();

  return (
    <header className={_classes.header}>
      <div aria-label='left'>
        {Boolean(onBack) && <BackspaceIcon cursor='pointer' onClick={onBack} />}
        <h1 className={_classes.title}>#{orderId}</h1>
      </div>
      <div aria-label='right'>
        <PrintIcon className={_classes.icon} onClick={handleToPrint} />
        <CloseIcon
          className={_classes.icon}
          onClick={e => onClose(e, 'escapeKeyDown')}
        />
      </div>
    </header>
  );
}

interface Props {
  orderId: OrderId;
  onBack: () => void;
  onClose: DrawerProps['onClose'];
}
